import { createLipSyncTracker } from "~/utils/lipsyncAnalytics.js";

export const REWARD_ANALYTICS_EVENT_IDS = Object.freeze({
  dialogOpen: "0023",
  dailyClaim: "0024",
  socialShare: "0025",
  postLinkSubmit: "0026",
  inviteCopy: "0027",
  referralVisit: "0028",
  registerStatus: "0029",
});

export const REWARD_ANALYTICS_SOURCES = Object.freeze({
  navGift: "reward_nav_gift",
  dailyClaim: "reward_daily_claim",
  balanceDailyClaim: "reward_balance_daily_claim",
  marketingDailyClaim: "reward_marketing_daily_claim",
  loginAutoGrant: "reward_login_auto_grant",
  referralLink: "reward_referral_link",
  referralCta: "reward_referral_cta",
  socialShare: "reward_social_share",
  postLinkSubmit: "reward_post_link_submit",
  inviteCopy: "reward_invite_copy",
  buyCredits: "reward_buy_credits",
  history: "reward_history",
  terms: "reward_terms",
});

function compactPayload(payload = {}) {
  return Object.fromEntries(
    Object.entries(payload).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );
}

function rewardPayload(type, payload) {
  return compactPayload({ type, ...payload });
}

export function createRewardAttemptId(prefix = "reward") {
  if (
    import.meta.client &&
    typeof globalThis.crypto?.randomUUID === "function"
  ) {
    return `${prefix}-${globalThis.crypto.randomUUID()}`;
  }
  return `${prefix}-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 10)}`;
}

export function isRewardAnalyticsSource(source) {
  return String(source || "").startsWith("reward_");
}

export function createRewardAnalyticsTracker(nuxtApp, userStore, route) {
  const tracker = createLipSyncTracker(nuxtApp, userStore, route);

  return {
    dialogOpen(payload = {}) {
      tracker.track(
        REWARD_ANALYTICS_EVENT_IDS.dialogOpen,
        rewardPayload("reward_dialog_open", payload)
      );
    },
    dailyClaim(payload = {}) {
      tracker.track(
        REWARD_ANALYTICS_EVENT_IDS.dailyClaim,
        rewardPayload("reward_daily_claim", payload)
      );
    },
    socialShare(payload = {}) {
      tracker.track(
        REWARD_ANALYTICS_EVENT_IDS.socialShare,
        rewardPayload("reward_social_share", payload)
      );
    },
    postLinkSubmit(payload = {}) {
      tracker.track(
        REWARD_ANALYTICS_EVENT_IDS.postLinkSubmit,
        rewardPayload("reward_post_link_submit", payload)
      );
    },
    inviteCopy(payload = {}) {
      tracker.track(
        REWARD_ANALYTICS_EVENT_IDS.inviteCopy,
        rewardPayload("reward_invite_copy", payload)
      );
    },
    referralVisit(payload = {}) {
      tracker.track(
        REWARD_ANALYTICS_EVENT_IDS.referralVisit,
        rewardPayload("reward_referral_visit", payload)
      );
    },
    registerStatus(payload = {}) {
      tracker.track(
        REWARD_ANALYTICS_EVENT_IDS.registerStatus,
        rewardPayload("reward_register_status", payload)
      );
    },
  };
}
